import React,{useState,useEffect} from 'react'
import { BrowserRouter as Router, Routes, Route, Link, NavLink, useParams } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import config from '../Config';

export const LegalIssuingSec = () => {

    const {seo_url} = useParams<any>();
        
return (
<>
<section className='legal-bx tc-pp-cc-cp-pg'>
<img src={`${config.siteBaseUrl}/assets/imgs/our-integrations-bg.svg`} className='legalbg' alt="" />
<div className='container'>
<div className='row'>
<div className='col-md-12'>
<div className="d-flex align-items-start">

<div className="accordion mblegal-mnu" id="faqaccordionExample">
<div className="accordion-item">
<h2 className="accordion-header" id="headingOne">
<button className="accordion-button collapsed" id="menuBtnResp" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
<NavLink to='' className="sidebar-linkmb" >
<span className="align-middle">Privacy Policy</span>
</NavLink>
</button>
</h2>
<div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
<div className="accordion-body">

<ul className="sidebar-nav groupaside">
<li className="sidebar-item">
<NavLink to={`/terms-and-conditions`} className="nav-link" >Terms and Conditions</NavLink>
</li>
<li className="sidebar-item">
<NavLink to={`/privacy-policy`} className="nav-link" >Privacy Policy</NavLink>
</li>
<li className="sidebar-item">
<NavLink to={`/payfac-terms-and-conditions`} className="nav-link" >Payfac Terms and Conditions</NavLink>
</li>
<li className="sidebar-item">
<NavLink to={`/code-of-conduct`} className="nav-link" >Code of Conduct</NavLink>
</li>
<li className="sidebar-item">
<NavLink to={`/cookies-policy`} className="nav-link" >Cookies Policy</NavLink>
</li>
<li className="sidebar-item">
<NavLink to={`/personal-guarantee`} className="nav-link" >Personal Guarantee</NavLink>
</li>
<li className="sidebar-item">
<NavLink to={`/ach-terms-and-conditions`} className="nav-link" >ACH Terms and Conditions</NavLink>
</li>
</ul>

</div>
</div>
</div>

</div>
<div className="nav flex-column nav-pills col-md-3" id="v-pills-tab" role="tablist" aria-orientation="vertical">
<NavLink to={`/terms-and-conditions`} className="nav-link" >Terms and Conditions</NavLink>
<NavLink to={`/privacy-policy`} className="nav-link" >Privacy Policy</NavLink>
<NavLink to={`/payfac-terms-and-conditions`} className="nav-link" >Payfac Terms and Conditions</NavLink>
<NavLink to={`/code-of-conduct`} className="nav-link" >Code of Conduct</NavLink>
<NavLink to={`/cookies-policy`} className="nav-link" >Cookies Policy</NavLink>
<NavLink to={`/personal-guarantee`} className="nav-link" >Personal Guarantee</NavLink>
<NavLink to={`/ach-terms-and-conditions`} className="nav-link" >ACH Terms and Conditions</NavLink>
<NavLink to={`/issuing-terms-conditions`} className="nav-link" >Issuing Terms and Conditions</NavLink>
</div>
<div className="tab-content">

<div className="tab-pane fade show active">
<div className="privacy_policy-sec">
<div className="container-nw">
<div className="title-sec">
<h2><span> Issuing Terms and Conditions </span></h2>
</div>

<div id="privacy_p" className="text-left doc-content">
<div className="pp-content">
<div className="text2">
<p>
These General Terms and Conditions (these “General Terms”), as incorporated by reference into the Master Services Agreement entered into by the Parties (the “MSA”), govern one or more Order Forms entered into by the Parties from time to time under the terms of the MSA and are effective upon full execution of the MSA. As used herein, “Agreement” means collectively:
</p>
</div>

<ul>
<li>1. The MSA</li>
<li>2. These General Terms</li>
<li>3. Each Order Form</li>
<li>4. Any Statement of Work</li>
<li>5. Any other exhibits attached to any of the foregoing</li>
<li>6. Any User Guides</li>
</ul>

<div className="pp-sub-head">
<h5>Scope & Services</h5>
</div>
<div className="text2">
<p>
These General Terms contain the standard terms and conditions applicable to Corpay’s provision of Services to Customer.</p>

<p>As used herein, “Services” means commercial payment automation services or commercial payments services, including provision of Corpay Mastercard Corporate Cards, which may include fleet, purchasing, T&E multi-cards and virtual cards (collectively, “Cards”), in each case provided by Corpay to Customer pursuant to one or more Order Forms and, if applicable, any custom services provided by Corpay to Customer pursuant to one or more Statements of Work.</p>

<p>Terms and conditions specific to each Service selected by Customer are set forth in an applicable Order Form and, if applicable, a Statement of Work.
</p>
</div>

<div className="pp-sub-head">
<h5>Custom Services</h5>
</div>
<div className="text2">
<p>To the extent Customer requires custom services, including, without limitation, custom reporting, data loads, dashboards, report distribution, training and other custom development work, Corpay may provide such custom services pursuant to a Statement of Work agreed to and executed by the Parties.</p>
<p>Such Statement of Work will include:</p>
<ul>
<li style={{ listStyle: 'disc' }}>A description of the scope of services to be performed by Corpay, y</li>
<li style={{ listStyle: 'disc' }}>Un estimated cost for such custom services based on Corpay’s applicable standard hourly rates in effect at the time of service.</li>
</ul>
<p>Upon execution, such Statement of Work will be incorporated into the Agreement and subject to these General Terms</p>
</div>

<div className="pp-sub-head">
<h5>Representations and Warranties</h5>
</div>
<div className="text2">
<p>
(a) Each Party represents and warrants to the other Party that:
<div className="sub-list">
<ul>
<li>(i) it has the power and authority to carry on its business as currently conducted and it is duly qualified to do business in each jurisdiction where the conduct of its business requires such qualification and where failure to qualify would have a material adverse effect on its operations;</li>
<li>(ii) the execution, delivery, and performance of the Agreement has been duly and validly authorized;</li>
<li>(iii) it has all governmental or quasi-governmental authorizations, permits, registrations, consents and licenses necessary for it to carry on its business as currently conducted;</li>
<li>(iv) the execution, delivery, and performance of the Agreement does not violate any provision of any Applicable Law;</li>
<li>(v) the execution, delivery, and performance of the Agreement does not, and will not, result in a breach of, or constitute a default under, any agreement to which it is a party or by which it is bound; and</li>
<li>(vi) any and all information provided to the other Party is true, accurate and complete in all material respects.</li>
</ul>
</div>
</p>
<p>(b) Customer represents and warrants that it is:
<div className="sub-list">
<ul>
<li>(i) a corporate or other similar legal entity validly registered, operating and physically located in the United States;</li>
<li>(ii) either a commercial, non-profit or governmental enterprise;</li>
<li>(iii) not a money services business as defined under the Bank Secrecy Act’s implementing regulations (“MSB”); and</li>
<li>(iv) not a shell bank, a non-licensed bank, a licensed money transmitter, a payment aggregator or bill payment facilitator.</li>
</ul>
</div>
</p>
<p>(c) EXCEPT AS OTHERWISE EXPRESSLY PROVIDED IN THE AGREEMENT, CORPAY DISCLAIMS ALL REPRESENTATIONS, WARRANTIES AND CONDITIONS OF ANY KIND (EXPRESS, IMPLIED, STATUTORY OR OTHERWISE, INCLUDING, BUT NOT LIMITED TO, THE WARRANTIES OF MERCHANTABILITY, FITNESS OR SUITABILITY FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT OF PROPRIETARY RIGHTS) TO THE FULLEST EXTENT PERMITTED BY LAW. CORPAY DOES NOT MAKE ANY WARRANTY THAT ANY OF THE SERVICES WILL BE UNINTERRUPTED, TIMELY, OR ERROR-FREE UNLESS OTHERWISE EXPRESSLY STATED IN THE AGREEMENT.</p>

</div>
<div className="pp-sub-head">
<h5>Customer Covenants; Acknowledgements</h5>
</div>
<div className="text2">
<p>
(a) Customer acknowledges and agrees that:
<div className="sub-list">
<ul>
<li>(i) it shall use the Services only for legitimate business charges and not for personal, household or consumer purposes;</li>
<li>(ii) it shall have neither consumer law rights nor remedies available to consumers associated with any purchases, charges or other activity associated with the Services;</li>
<li>(iii) it shall only use the Services to make payments on its own behalf and not on behalf of any third party;</li>
<li>(iv) it shall use the Services only for valid and lawful purposes and not for gambling, online gaming, illicit drug transactions, or for any unlawful purpose including, without limitation:
<ul>
<li>(a) illegal purchases of goods or services, regardless of whether such transaction violates the laws applicable in the territory where the transaction was initiated or merchant is located, or</li>
<li>(b) purchases that are prohibited by local law;</li>
</ul>
</li>   
<li>(v) it shall not use the Services for speculative purposes or any payments relating to MSBs, virtual currency, materials that incite violence, hatred, or racism or are considered obscene, or any entity that Corpay has notified Customer poses a fraud or chargeback risk or that Corpay deems, in its reasonable discretion, to pose a reputational risk to Corpay, the Issuing Bank or Mastercard;</li>
<li>(vi) it shall not, and shall not permit any third party to, use the Services in any way that would cause Customer, Corpay or Issuing Bank to violate Applicable Law; and</li>
<li>(vii) it shall permit Corpay to reasonably investigate or audit Customer’s compliance with Applicable Laws.</li>
</ul>
</div>
</p>
<p>If Customer uses, or permits a third party to use, the Services in violation of the Agreement, Customer shall be solely responsible for such use and shall reimburse Corpay, the Issuing Bank, and Mastercard for all amounts, expenses or liabilities such parties may incur as a result of such use.</p>

<p>(b) Customer acknowledges that Corpay is not a bank or MSB and does not offer banking or MSB services.
Customer acknowledges that Corpay does not guarantee or have control over or liability for:
<div className="sub-list">
<ul>
<li>(i) the products, services, or other consideration Customer receives from its vendors;</li>
<li>(ii) the accuracy of the invoices Customer receives from its vendors; and</li>
</ul>
</div>
</p>

<p>(c) Upon Customer’s request, Corpay will use commercially reasonable efforts to stop a payment or reverse a payment transaction once such transaction has entered the banking system, but Customer acknowledges that Corpay may not be able, and shall have no liability for any failure, to stop or reverse such payment transaction.</p>
<p>If Customer requests to cancel or stop a payment to a vendor outside the U.S., Customer shall bear all currency exchange and processing costs and fees associated with the reversal of the payment, including trading losses.</p>

<p>(d) Customer shall obtain and maintain all necessary authorizations to provide Corpay with the information that is owned by or relates to any third party prior to providing such information to Corpay.<br/>
All information provided by Customer to Corpay in connection with the provision and receipt of Services shall be accurate, complete and timely in all respects during the Term, including, as applicable, Customer’s or any vendor’s bank account information, authorized contacts, e-mail addresses, mailing addresses and other contact information.</p>

<p>Corpay shall be entitled to rely on any such information (including, without limitation, any vendor payment information) provided by Customer without independent verification, and shall have no liability for any damages resulting from any inaccurate, incomplete or untimely information provided by Customer.</p>

<p>Corpay reserves the right to suspend or terminate Customer’s use of any portion of the Services for providing inaccurate or incomplete information or for failing to provide accurate and complete information as required to facilitate Corpay’s fulfillment of its obligations under the Agreement.</p>

</div>
<div className="pp-sub-head">
<h5>Confidential and Proprietary Information</h5>
</div>
<div className="text2">
<p>
(a) To effectuate the Agreement, it may be necessary for each Party (the “Disclosing Party”) to disclose to the other Party (the “Receiving Party”) certain of its proprietary or confidential information in furtherance of the objectives of the Agreement or to permit the Parties to perform their respective obligations hereunder, including, without limitation, the rates, terms and conditions of the Agreement; technical information; transaction information; or any of the procedures, practices or confidential dealings of the Disclosing Party (the “Confidential Information”).
</p>
<p>Notwithstanding anything to the contrary in the Agreement, business information with respect to vendors that are independently verified with such vendor or collected from such vendor by Corpay shall not be deemed Customer’s Confidential Information.<br/>
The Disclosing Party shall identify as confidential or proprietary, or mark as confidential or proprietary, any information disclosed to the Receiving Party that it deems to be Confidential Information; provided, however, that it shall not be necessary to identify as confidential any information that by its nature should reasonably be known to be confidential or that the Receiving Party accesses through systems or facilities of the Disclosing Party.</p>
<p>Confidential Information shall be and shall remain the exclusive property of the Disclosing Party.</p>
<p>The Receiving Party shall:</p>  
<div className="sub-list">
<ul>
<li>(i) not disclose Confidential Information of the Disclosing Party to any third party without the prior written approval of the Disclosing Party or as otherwise permitted under the Agreement;</li>
<li>(ii) keep Confidential Information of the Disclosing Party confidential and to use at least the same level of care to prevent disclosure or unauthorized use of such Confidential Information as the Receiving Party exercises in protecting its own Confidential Information of a similar nature, but in no event less than a reasonable degree of care;</li>
<li>(iii) return promptly to the Disclosing Party or destroy all copies and derivatives of Disclosing Party’s Confidential Information upon the Disclosing Party’s written request; and</li>
<li>(vi) use Disclosing Party’s Confidential Information only for purposes of furthering the objectives of the Agreement or as permitted under the Agreement.</li>
</ul> 
</div>                                                     
<p>The confidentiality obligations set forth in this Section 5(a) shall survive any termination or expiration of the Agreement for a period of three <br/>
(3) years thereafter; provided that, as it relates to any Confidential Information that qualifies as a trade secret, such confidentiality obligations shall survive any termination or expiration of the Agreement for so long as such Confidential Information continues to qualify as a trade secret under Applicable Law.<br/></p>

<p>(b) The confidentiality obligations set forth in Section 5(a) above shall not apply to any Confidential Information that:</p>
<div className="sub-list">
<ul>
<li>(i) was in the Receiving Party’s possession without any obligation of confidentiality prior to receipt from the Disclosing Party;</li>
<li>(ii) was received in good faith from a third party not subject to a confidentiality obligation;</li>
<li>(iii) now is or later becomes publicly known through no breach of confidentiality obligation by the Receiving Party;</li>
<li>(iv) was developed by the Receiving Party without use of or reference to any of the Disclosing Party’s Confidential Information; or</li>
<li>(v) is required to be disclosed pursuant to subpoena or other process issued by a court or administrative agency having appropriate jurisdiction; provided that, if permitted by Applicable Law, the Receiving Party gives the Disclosing Party sufficient prior notice to permit the Disclosing Party to seek a protective order or an exemption from such requirement.</li>
</ul>
</div>
<p>c) If Customer was referred to Corpay by a third-party referral or co-marketing partner with which Corpay has entered into a co-marketing, referral or other similar agreement (a “Referral Partner”), then Customer authorizes Corpay to provide the Referral Partner with certain information regarding Customer’s use of the Services on a regular basis, including, but not limited to, information regarding Customer’s spend volumes.</p>
<p>If Customer has entered into a separate agreement with TCB Pay (“Integration Partner”) as an integration partner of Corpay pursuant to which Integration Partner provides account management or other services to Customer, then Customer authorizes Corpay to provide Integration Partner with:</p>
<div className="sub-list">
<ul>
<li>(i) access to Customer’s account information with Corpay, including certain administrative functions, and</li>
<li>(ii) Customer’s transaction data in Corpay’s possession or control.</li>
</ul>
</div>

<p>Customer acknowledges and agrees that Corpay shall have no liability to Customer for any actions or inaction of any Referral Partner or Integration Partner, and Customer agrees to indemnify and hold harmless Corpay from any damages, liabilities, costs or expenses (including reasonable attorneys’ fees and litigation costs) arising out of or in connection with any action or inaction by any Referral Partner or Integration Partner.<br/></p>

<p>(d) Customer acknowledges and agrees that:</p>
<div className="sub-list">
<ul>
<li>All application software developed, utilized and maintained by Corpay (including any software related to the Services provided by Corpay hereunder),</li>
<li>The internal hardware utilized by Corpay,</li>
<li>The internal operating procedures employed by Corpay,</li>
<li>Technical information (such as file record layouts),</li>
<li>And transaction information, including (without limitation) Card numbers and any data or information gathered by Corpay, whether at the point-of-sale or otherwise, are solely Corpay’s Confidential Information and, as such, are the exclusive and proprietary property of Corpay.</li>
</ul>
</div>

<p>If applicable, the bank identification numbers assigned to all Cards issued in connection with the Services are the property of the Issuing Bank.</p>

<p>(e) Except as required to facilitate Corpay’s performance of any of its obligations under the Agreement, Customer shall not disclose to Corpay any personally identifiable information that constitutes protected health information as defined under the HIPAA Privacy Rules.
Provided, however, that neither vendor payment information nor vendor payment methods constitute information that can identify, either directly or indirectly, a natural person.<br/></p>

<p>(f) If applicable, Customer shall:</p>
<div className="sub-list">
<ul>
<li>Maintain the confidentiality of any user identification and password (“Login Credentials”) used to access or use any of the Services,</li>
<li>Not transfer such Login Credentials, or lend or otherwise transfer access to or use of the Services, to any third party,</li>
<li>Immediately notify Corpay of any unauthorized use of, or any other breach of security related to, the Login Credentials.</li>
</ul>
</div>

<p>Customer shall be responsible for all transactions conducted using Customer’s Login Credentials, and Corpay shall have no liability for any loss or damage arising from Customer’s failure to comply with the obligations set forth in this Section 5(f).</p>


</div>
<div className="pp-sub-head">
<h5>Software Ownership, License and ISP</h5>
</div>
<div className="text2">
<p>(a)Corpay owns all of the right, title and interest in and to, or has valid licenses to use and incorporate, any software made available to Customer in connection with the Services (the “Corpay Software”).</p>
<p>The Corpay Software is protected by copyright, trademark, patent and/or other intellectual property or proprietary rights and laws.Effective upon the full execution of any applicable Order Form or Statement of Work entered into by the Parties under the terms of the MSA, and subject to the terms and conditions of these General Terms, Corpay hereby grants to Customer, and Customer hereby accepts from Corpay, a limited, nonexclusive, nontransferable, terminable, revocable, and non-sublicensable license to use the Corpay Software solely in the format provided to Customer by Corpay for the sole purpose of accessing and using the Services. Corpay and/or its licensors shall retain ownership of all aspects of the Corpay Software, including all right, title, and interest in and to the Corpay Software and all intellectual property rights in the Corpay Software; </p>
<p>Corpay and/or its licensors shall retain ownership of all aspects of any work of authorship (including software) that is based upon all or any portion of the Corpay Software, such as a translation, modification, correction, addition, extension, upgrade, improvement, adaptation, abridgment, recasting, transformation, or elaboration (“Derivative Technology”) (regardless of creator), including all right, title and interest in and to the Derivative Technology and all intellectual property rights in the Derivative Technology.</p>
<p>Upon the expiration or termination of the Agreement, the applicable Order Form, or the applicable Statement of Work, the licenses and related rights herein granted to Customer shall immediately terminate in their entirety and revert to Corpay, and Customer shall cease any further use of Corpay’s trademarks, the Corpay Software, Derivative Technology, and any Corpay intellectual property rights therein.</p>
<p>All rights not expressly granted to Customer hereunder are reserved to Corpay and its licensors.</p>
<p>(b) To use Corpay Software and the Services, Customer must have its own Internet Service Provider (“ISP”) or other means of accessing the Internet, the necessary computer equipment and software, and a compatible browser.</p>
<div className="sub-list">
<ul>
<li>Corpay is not responsible for the actions or inactions of Customer’s ISP.</li>
<li>Corpay is not responsible for any error, failure or malfunction of Customer’s computer or software.</li>
<li>Corpay is not responsible for, and Customer shall indemnify and hold Corpay harmless from any damages, liabilities, costs or expenses (including reasonable attorneys’ fees and litigation costs) arising out of or in connection with, any security breach, compromise, intrusion, misuse and/or failure accomplished via, using, or exploiting Customer’s firewall, computer hardware, computer software, or computer network through which Customer accesses the Corpay Software or any Services.</li>
</ul>
</div>

</div>
<div className="pp-sub-head">
<h5>Default; Termination</h5>
</div>
<div className="text2">
<p>(a) In the event of Customer’s breach or default under the payment terms of the Agreement, Corpay shall have the right to immediately suspend any of the Services until such breach is cured.</p>
<div className="sub-list">
<ul>
<li>In the event such breach or default is not cured within a reasonable period not to exceed thirty (30) days, Corpay may thereafter terminate the Agreement, the applicable Order Form, or the applicable Statement of Work upon written notice to Customer.</li>
<li>In the event of any other default under the Agreement by either Party, the non-defaulting Party shall provide the defaulting Party written notice of the nature of the default.</li>
<li>The defaulting Party shall have thirty (30) days from the date of the default notice to cure the default, and if the default is not cured within such period, then the non-defaulting Party may thereafter terminate the applicable Order Form or the applicable Statement of - Work upon written notice to the defaulting Party.</li>
<li>In addition to any other rights of termination hereunder, either Party may terminate the Agreement, the applicable Order Form, or the applicable Statement of Work upon prior written notice with respect to any individual state or jurisdiction if the terminating Party can demonstrate, with documentary support, that changes in Applicable Laws or the interpretation thereof will make the performance of such Party’s obligations hereunder, under the applicable Order Form, or under the applicable Statement of Work not commercially feasible.</li>
<li>The effective date of termination under the preceding sentence will be ninety (90) days from the date notice is delivered, or upon the effective date of the new or amended Applicable Law, whichever occurs sooner.</li>
<li>Customer’s obligation to pay for all outstanding amounts incurred before the effective date of termination shall survive termination.</li>
</ul>
</div>
<p>For clarity, any notice of termination of an individual Order Form or Statement of Work shall not be construed as a notice of termination for the entire Agreement, any other Order Form, or any other Statement of Work unless such notice expressly provides for such termination.</p>
<p>(b) Corpay may immediately terminate the Agreement, any Order Form, or any Statement of Work in the event that the Mastercard network or Regions Bank or a successor financial institution (the “Issuing Bank”) prohibits any of the Services or the Issuing Bank ceases to be a network member of Mastercard or a payment card issuer; provided, however, that Corpay shall endeavor to provide Customer with advance notice thereof.</p>
<p>(c) For purposes of the Agreement, the term “Applicable Law” means the following, as in effect from time to time:</p>
<div className="sub-list">
<ul>
<li>Any and all applicable federal, state, provincial and local laws, statutes, ordinances, orders, codes, rules, regulatory guidance, regulations or other requirements having the force of law that govern or affect the Agreement, the subject matter under the Agreement, or the Parties rights and obligations under the Agreement;</li>
<li>Any and all supervisory directives, policies, practices, protocols, standards and guidance of regulators having jurisdiction over the Issuing Bank governing or affecting the Agreement, or the subject matter thereof,</li>
<li>Any and all directives, policies, practices, protocols, codes, standards and guidance of regulators which, although not necessarily having force of law, is regarded by such regulator as requiring compliance as if they had force of law; and</li>
<li>Any and all bylaws, rules, operating regulation, guidelines, requirements, standards, or mandates of any kind promulgated from time to time by the Mastercard or other network.</li>
</ul>
</div>
</div>
<div className="pp-sub-head">
<h5>Indemnification; Limitation of Liability</h5>
</div>
<div className="text2">
<p>(a) Customer shall indemnify, defend and hold harmless Corpay, its affiliates, and their respective officers, directors, members,
shareholders, employees, agents, contractors, successors and assigns (each a “Corpay Indemnified Party”), from and against any and all claims, suits, actions, proceedings, losses, damages, liabilities, costs and expenses (including reasonable attorneys’ fees and expenses) asserted by a third party (collectively, “Indemnified Losses”) relating to: </p>
<div className="sub-list">
<ul>
<li>(i) any breach of the Agreement by Customer or any of Customer’s employees, agents and contractors; </li>
<li>(ii) any payment initiated or made by Customer using the Services; and (iii) any other action taken or omitted by Corpay pursuant to Customer’s instructions or in reliance on information provided by Customer, except to the extent such Indemnified Losses are caused solely by Corpay’s breach of the Agreement.</li>
</ul>
</div>
<p>(b) IN NO EVENT SHALL EITHER PARTY HAVE LIABILITY TO THE OTHER FOR INDIRECT, CONSEQUENTIAL, SPECIAL,
INCIDENTAL OR PUNITIVE DAMAGES, OR DAMAGES FOR LOSS OF PROFITS, LOSS OR INTERRUPTION OF BUSINESS, LOSS OF USE, LOSS
OF DATA, LOSS OF OTHER INTANGIBLES, LOSS OF SECURITY OF INFORMATION, OR UNAUTHORIZED INTERCEPTION OF ANY SUCH
INFORMATION BY THIRD PARTIES, WHETHER SUCH LIABILITY IS ASSERTED ON THE BASIS OF CONTRACT, TORT (INCLUDING NEGLIGENCE
OR STRICT LIABILITY), OR OTHERWISE AND REGARDLESS OF WHETHER SUCH PARTY WAS MADE AWARE OF THE POSSIBILITY OF SUCH
DAMAGES. CORPAY’S SOLE RESPONSIBILITY, AND CUSTOMER’S SOLE AND EXCLUSIVE REMEDY, FOR DAMAGES CAUSED BY CORPAY’S
BREACH OF THE AGREEMENT, ERROR, DELAY, OR ANY ACTION OR FAILURE TO ACT SHALL BE LIMITED DURING THE TERM TO DIRECT
MONETARY DAMAGES NOT TO EXCEED THE TOTAL CORPAY REVENUE EARNED UNDER THE APPLICABLE ORDER FORM OR STATEMENT
OF WORK DURING THE TWELVE (12) MONTHS IMMEDIATELY PRECEDING THE INCURRENCE OF SUCH LOSS. FOR CLARITY, WITH RESPECT
TO ANY LIABILITY THAT CUSTOMER SEEKS TO RECOVER FROM CORPAY, THE APPLICABLE LIMITATION OF CORPAY’S LIABILITY SHALL BE
DETERMINED BASED ON THE CORPAY REVENUE EARNED UNDER THE ORDER FORM OR STATEMENT OF WORK PROVIDING FOR THE
SERVICES GIVING RISE TO SUCH LIABILITY. FOR PURPOSES OF THIS PROVISION, “CORPAY REVENUE” SHALL MEAN THE PORTION OF
MASTERCARD INTERCHANGE RECEIVED AND RETAINED BY THE APPLICABLE CORPAY AFFILIATE WITH RESPECT TO CUSTOMER’S SPEND
ONLY THROUGH THE SPECIFIC SERVICES GIVING RISE TO LIABILITY, PLUS ANY FEES PAID BY CUSTOMER TO CORPAY AND EXCLUDING
ANY INCENTIVE OR REBATE AMOUNTS PAID TO CUSTOMER, CHARGE BACKS, AND/OR CREDIT LOSSES IN CONNECTION WITH SUCH
SERVICE.</p>


</div>
<div className="pp-sub-head">
<h5>Fees</h5>
</div>
<div className="text2">
<p>
Customer agrees to pay to Corpay the fees set forth in each applicable Order Form and Statement of Work. Corpay shall submit invoices to Customer for any such fees payable to Corpay. For all setup fees set forth in an applicable Order Form or Statement of Work, Corpay shall submit an invoice upon Customer’s execution of the applicable Order Form or Statement of Work. Customer shall pay any and all one-time setup or implementation fees set forth in each Order Form within thirty (30) days after Customer’s execution of such Order Form.Corpay shall commence submission of invoices to Customer for all monthly and transactional fees set forth in each Order Form ninety (90) days after Customer’s execution of the applicable Order Form(s) or, if applicable, within thirty (30) days after the first production transaction through the applicable Services. Customer shall pay each invoice within thirty (30) days after the date of such invoice.
</p>
</div>
<div className="pp-sub-head">
<h5>Statements; Reporting</h5>
</div>
<div className="text2">
<p>
If applicable, Corpay shall make available on-line billing statements and reports. For statements involving Cards, Customer understands and agrees that Corpay may filter data received from merchants from time to time as necessary to provide complete reporting information to Customer when the merchant is unable to deliver complete purchase detail.
</p>


<div className="pp-sub-head">
<h5>Disputed Items</h5>
</div>
<div className="text2">
<p>If applicable, Customer must notify Corpay in writing of any disputed item on Customer’s billing statement within sixty (60) days after the date of the billing statement, or such billing statement will be deemed undisputed and accepted by Customer.</p>
<div className="sub-list">
<ul>
<li>Unless required by law, Corpay is not responsible for any problem Customer may have with any goods or services charged to any Cards issued to Customer.</li>
<li>If Customer has a dispute with a merchant about a transaction involving a Card, Customer must pay Corpay and attempt to resolve the dispute with the merchant prior to sending the dispute to Corpay.</li>
<li>If Customer is unsuccessful in resolving the dispute directly with the merchant, Corpay will attempt to process the dispute through Mastercard subject to the Mastercard rules, as they may be changed from time to time in Mastercard’s sole discretion.</li>
<li>Corpay is not responsible if any merchant refuses to honor Cards.</li>
</ul>
</div>

</div>
<div className="pp-sub-head">
<h5>Right of Setoff and Recoupment</h5>
</div>
<div className="text2">
<p>
Corpay shall have the right to setoff and apply any amounts owing by Corpay to Customer against any amounts owing from Customer to Corpay pursuant to any agreement between Corpay and Customer or any amounts in the possession of or under the control of Corpay.
</p>
</div>

<div className="pp-sub-head">
<h5>Force Majeure</h5>
</div>
<div className="text2">
<p>
Each Party shall be excused from performance under the Agreement for any period to the extent such Party is prevented from performing any obligation, in whole or in part, as a result of:
</p>
<p>(a) causes beyond its reasonable control and without its negligent or willful misconduct, including without limitation:</p>

<div className="sub-list">
<ul>
<li>acts of God,</li>
<li>fires,</li>
<li>floods,</li>
<li>explosions,</li>
<li>civil disturbances,</li>
<li>natural disasters,</li>
<li>war,</li>
<li>acts of terrorism or other hostilities,</li>
<li>labor disputes,</li>
<li>governmental acts, orders or regulations,</li>
<li>acts of Mastercard,</li>
<li>third-party nonperformance,</li>
<li>failures or fluctuations in electrical power, heat, light, air conditioning or telecommunications equipment; and/or</li>

</ul>
</div>
<p>
b) such party having a reasonable belief that performing such obligation would violate any Applicable Law.
</p>
</div>

<div className="pp-sub-head">
<h5>Monitoring and/or Recording Communication</h5>
</div>
<div className="text2">
<p>Customer understands and agrees that Corpay may in its discretion, but is not obligated to, monitor and/or record any telephone calls or other communications between Corpay and Customer or Customer’s employees or agents without any further notice for quality control and other purposes related to the Services.</p>
<p>Corpay may use the resulting information for internal purposes or as may be required by Applicable Law. Customer hereby consents to Corpay’s monitoring and/or recording of any telephone calls and communications with Customer or its employees or agents.</p>
<p>Customer acknowledges that Corpay may not record all telephone calls or communications, and Corpay does not guarantee that recordings of any particular telephone call or communication will be retained or capable of being retrieved.</p>
</div>
<div className="pp-sub-head">
<h5>Taxes</h5>
</div>
<div className="text2">
<p>Customer is solely responsible for any and all tax related obligations in connection with using the Services, including, without limitation, proper withholding and reporting.</p>
<p>Customer agrees to indemnify and hold the Corpay Indemnified Parties harmless from any and all liabilities, including interest and penalties, which are or may be imposed on the Corpay Indemnified Parties pursuant to any such federal, state and local tax laws and regulations.</p>

</div>
<div className="pp-sub-head">
<h5>Press Releases, Publicity, Etc.</h5>
</div>
<div className="text2">
<p>
Customer shall not issue any press release or disseminate similar publicity or other information regarding the Agreement or the Services provided thereunder without Corpay’s prior written consent.
</p>
<p>
Furthermore, Customer shall not utilize the trademarks, service marks, trade names or logos of Corpay, Issuing Bank or Mastercard, including, without limitation, website information, instructional or marketing materials or brochures, without the express prior written consent of Corpay, Issuing Bank or Mastercard, as appropriate.
</p>


</div>
<div className="pp-sub-head">
<h5>Independent Contractors</h5>
</div>
<div className="text2">
<p>
None of the provisions of the Agreement are intended to create nor shall be deemed or construed to create any relationship between the Parties other than that of independent entities contracting with each other solely for the purpose of effecting the provisions of the Agreement.
</p>

</div>
<div className="pp-sub-head">
<h5>Compliance</h5>
</div>
<div className="text2">
<p>
To help the government fight the funding of terrorism and money laundering activities, U.S. federal law requires Corpay to obtain, verify, and record information that identifies Customer (and any guarantor or co-maker) as part of initial and on-going customer review processes.
Therefore, Corpay may, at Corpay’s sole discretion, require Customer to provide various identifying information that will allow Corpay to properly identify Customer, which may include, without limitation:
</p>
<div className='sub-list'>
<ul>
<li>name</li>
<li>address</li>
<li>taxpayer identification number, and</li>
<li>other information.</li>
</ul>
</div>
<p>Customer represents and covenants that:</p>
<div className='sub-list'>
<ul>
<li>(i) Customer and, if applicable, any person to whom Customer provides a Card are not currently and shall not become subject to any law, regulation or list of any government agency (including, without limitation, the U.S. Office of Foreign Asset Control list) that prohibits or limits Corpay from conducting business with Customer;</li>
<li>(ii) Customer shall provide to Corpay, Mastercard or Issuing Bank, upon such party’s request, documentary and other evidence of Customer’s identity or, if applicable, the identity of any person to whom Customer provides a Card, so that Corpay may comply with any Applicable Law or Corpay’s Anti-Money Laundering Policy.</li>
</ul>
</div>
<p>Corpay may, at its sole discretion, take any action to comply with Applicable Laws concerning money movement, may refuse to make any payment on behalf of Customer, and, if Corpay reasonably believes that any of the Services have been or are being used for any unauthorized, illegal or criminal purpose, disclose to law enforcement information about Customer, Customer’s account and transactions — without any liability to Corpay.</p>
<p>Corpay shall endeavor to provide Customer with advance notice unless prohibited by Applicable Law.</p>


</div>
<div className="pp-sub-head">
<h5>Privacy Policy</h5>
</div>
<div className="text2">
<p>
Corpay’s privacy policy, available online at https://www.fleetcor.com/en/privacy-policy.html, governs Customer’s use of the Services.<br/>
The Privacy Policy explains how Corpay treats Customer’s personal data and protects Customer’s privacy when Customer uses the Services.
</p>
<div className='sub-list'>
<ul>
<li>Corpay owns any and all data it collects from Customer.</li>
<li>The Privacy Policy also explains Customer’s privacy rights, if any.</li>
<li>You agree to be bound by and to comply with the Privacy Policy, which is incorporated by reference herein.</li>
<li>You also acknowledge that any information Customer provides or gives Corpay permission to access may also be used by Corpay’s domestic and international affiliates and partners in connection with an offer of services to Customer. </li>
<li>In the event of conflict between this MSA and the Privacy Policy, the terms of the Privacy Policy shall control.</li>
</ul>
</div>



</div>
<div className="pp-sub-head">
<h5>Notices</h5>
</div>
<div className="text2">

<p>All notices or other communications required or permitted under the Agreement shall be in writing and deemed given:</p>
<div className='sub-list'>
<ul>
<li>(i) when hand delivered;</li>
<li>(ii) if sent by email, 24 hours after sending unless a delivery failure is received;</li>
<li>(iii) if by recognized express courier service, on the delivery date recorded by the courier;</li>
<li>(iv) if by U.S. certified mail, three (3) business days after mailing with first-class postage and return receipt requested.</li>
</ul>
</div>
<p>Notice shall be addressed:</p>
<div className='sub-list'>
<ul>
<li>If to Customer, using the contact information in the MSA.</li>
<li>If to Corpay:<br /><strong>Corpay</strong> 5301 Maryland Way <br /> Brentwood, TN 37027<br /> Attention: General Counsel</li>
</ul>
</div>




</div>
<div className="pp-sub-head">
<h5>Jurisdiction; Disputes</h5>
</div>
<div className="text2">

<p>The Agreement shall be governed exclusively by the laws of the State of Delaware, without regard to conflict of law rules.
In the event of a dispute, claim, or disagreement (“Dispute”), the aggrieved Party shall notify the other in writing with specific terms of the Dispute.</p>
<p>Parties shall use commercially reasonable efforts to resolve it within 30 days.<br/> If unresolved, the Dispute shall be finally settled by binding arbitration administered by the American Arbitration Association, in accordance with its rules for commercial disputes.</p>
<div className='sub-list'>
<ul>
<li>Arbitration will be confidential, in Wilmington, Delaware (or another location if agreed).</li>
<li>Before a single arbitrator, unless the dispute exceeds $500,000, in which case either party may request a panel of three arbitrators.</li>
<li>The award shall be in writing with full legal and factual explanation.</li>
<li>The arbitrator may award Costs (including attorney fees, arbitrator fees, expenses) to the prevailing party at their discretion.</li>
</ul>
</div>

</div>

<div className="pp-sub-head">
<h5>Miscellaneous</h5>
</div>
<div className="text2">

<p>(a) Failure to enforce any part of the Agreement does not waive future enforcement rights.<br/>
(b) Corpay may change terms due to Applicable Law or Mastercard rules, giving 30 days' notice (or less, if required). Customer can object in writing within 10 days. If not withdrawn, changes go into effect; Customer may terminate the Order Form within 15 days.<br/>
(c) Any surviving provisions remain enforceable post-termination.<br/>
(d) Section headings are for reference only.<br/>
(e) If any part is invalid or unenforceable, the rest remains valid.<br/>
(f) No drafting presumption applies — both Parties participated equally.<br/>
(g) Customer may not assign the Agreement without Corpay's consent.<br/>
(h) Corpay may use third parties to fulfill its obligations but remains responsible.<br/>
(i) Electronic records and signatures are legally binding.<br/>
(j) If unpaid amounts are referred to collection, Customer agrees to cover costs, including attorney and court fees.<br/>
(k) All fees must be paid in U.S. dollars.<br/>
(l) Corpay is not responsible for vendor bank charges related to receiving Customer funds.</p>

</div>



</div>
</div>
</div>
</div>
</div>
</div>

</div>
</div>
</div>
</div>
</div>
<img src={`${config.siteBaseUrl}/assets/imgs/blue-lowerdots.svg`} alt="" className="orng-dots" />
</section>
</>
    )
}
